import * as checkoutTypes from '~~/common/config/CheckoutTypes';
import type { CheckoutType } from '~~/common/config/CheckoutTypes';

export function parseGuestCheckoutStringToArray (guestCheckoutString: unknown) {
  if (typeof guestCheckoutString !== 'string') {
    return [];
  }
  return guestCheckoutString.split(/\s+/).filter(str => str);
}

export function isValidCheckoutTypeGuard (checkoutType: unknown): checkoutType is CheckoutType {
  return Object.values(checkoutTypes).includes(checkoutType as CheckoutType);
}
